"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var testUtils_exports = {};
__export(testUtils_exports, {
  makeLocalesTest: () => makeLocalesTest
});
module.exports = __toCommonJS(testUtils_exports);
var import_intl_messageformat = require("intl-messageformat");
function makeLocaleMatcher(target) {
  return Object.entries(target).reduce(
    (obj, [key, value]) => ({
      ...obj,
      [key]: typeof value === "string" ? expect.any(String) : makeLocaleMatcher(value)
    }),
    {}
  );
}
__name(makeLocaleMatcher, "makeLocaleMatcher");
const langs = ["en", "ru", "pt-br"];
function getPlaceholders(message) {
  const placeholders = /* @__PURE__ */ new Set();
  const visit = /* @__PURE__ */ __name((nodes) => {
    for (const node of nodes) {
      if (node.type >= 1 && node.type <= 6 && node.value !== void 0) placeholders.add(node.value);
      if (node.options !== void 0) Object.values(node.options).forEach((option) => visit(option.value));
      if (node.children !== void 0) visit(node.children);
    }
  }, "visit");
  visit(new import_intl_messageformat.IntlMessageFormat(message, "en-US", void 0, { ignoreTag: true }).getAst());
  return [...placeholders].sort();
}
__name(getPlaceholders, "getPlaceholders");
function checkPlaceholders(source, target) {
  for (const [key, value] of Object.entries(source)) {
    const translated = target[key];
    if (typeof value === "string") {
      expect(typeof translated).toBe("string");
      expect(getPlaceholders(translated)).toEqual(getPlaceholders(value));
    } else {
      expect(translated).toBeDefined();
      checkPlaceholders(value, translated);
    }
  }
}
__name(checkPlaceholders, "checkPlaceholders");
function makeLocalesTest(loader) {
  return async () => {
    const [target, ...rest] = await Promise.all(langs.map(loader));
    const matcher = makeLocaleMatcher(target);
    rest.forEach((loc) => {
      expect(loc).toMatchObject(matcher);
      checkPlaceholders(target, loc);
    });
  };
}
__name(makeLocalesTest, "makeLocalesTest");
//# sourceMappingURL=testUtils.js.map
